const mutation = {
    create: `
    mutation createBooking($data: JSONString!) {
        createBooking (data: $data) {
            status,
            res{
                referenceNum
                dateCreated
            },
            message
        }
    }
    `,
    update: `
        mutation updateBooking($data: JSONString!) {
            updateBooking (data: $data) {
                status,
                res,
                message
            }
        }
    `,
    resendBooking: `
        mutation resendBooking($data: JSONString!) {
            resendBooking (data: $data) {
                status,
                res,
                message
            }
        }
    `,
    cancelBooking: `
        mutation cancelBooking($data: JSONString!) {
            cancelBooking (data: $data) {
                status,
                res,
                message
            }
        }
    `,
    saveBookingFeedback: `
        mutation saveBookingFeedback($data: JSONString!) {
            saveBookingFeedback (data: $data) {
                status,
                res,
                message
            }
        }
    `,
};

const query = {
    bookingList: `
    query bookingList(
        $id: String!, 
    ) {
        bookingList(
            id: $id
        ) {
            id
            patronId
            publicId
            itemId
            referenceNum
            itemName
            itemCode
            itemRate
            itemPhotoUrl
            name
            contact
            address
            email
            department
            purpose
            timeOfBooking
            startFormatted
            endFormatted
            start
            end
            status
            title
            duration
            total
            backgroundColor
            inspectionRequired
            textColor
            display
            editable
            statusBanned
            dateCreated
            dateUpdated  
            type
        }
      }
  `,
    bookingAvailable: `
    query bookingAvailable(
        $id: String!, 
    ) {
        bookingAvailable(
            id: $id
        ) {
            id
            patronId
            publicId
            itemId
            referenceNum
            itemName
            itemCode
            itemRate
            itemPhotoUrl
            name
            contact
            address
            email
            department
            purpose
            timeOfBooking
            startFormatted
            endFormatted
            start
            end
            status
            title
            duration
            total
            backgroundColor
            inspectionRequired
            textColor
            display
            editable
            statusBanned
            dateCreated
            dateUpdated  
            type
        }
      }
  `,
    publicBookingList: `
    query publicBookingList($data: JSONString!) {
        publicBookingList(data: $data) {
            id
            patronId
            publicId
            itemId
            referenceNum
            itemName
            itemCode
            itemRate
            itemType
            statusInspection
            itemPhotoUrl
            name
            contact
            hasDeffective
            address
            email
            department
            purpose
            timeOfBooking
            startFormatted
            endFormatted
            start
            end
            status
            title
            duration
            total
            backgroundColor
            textColor
            display
            editable
            statusBanned
            dateCreated
            dateUpdated  
            assignedDriver
            type
        }
      }
  `,
    bookingFeedback: `
    query bookingFeedback(
        $id: String!, 
    ) {
        bookingFeedback(
            id: $id
        ) {
            id
            isSatisfied
            notes
            dateCreated
            dateUpdated  
        }
    }
  `,
    searchBookingPatron: `
    query searchBookingPatron($empId: String!, $email: String!) {
        searchBookingPatron(email: $email, empId: $empId) {
            departmentName
            id
            patronNameWId
            name
            fullAddress
            lat
            lng
            emergencyContact
            email
            departmentName
            blacklist {
                id
            }
            booking {
                status
            }
        }
    } 
  `,
    bookingItemTypesList: `
    query bookingItemTypesList {
        bookingItemTypesList {
          id,
          name,
          terms,
          inspectionRequired,
          dateCreated,
          dateUpdated
        }
      }
  `,
    getCrmUser: `
        query getCrmUser($usersId: String!) {
        getCrmUser(usersId: $usersId) {
            id
    		bookingConfigFilter
        }
    }
    `,
}

export { mutation, query };